export var emptyObject = {};